var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "regular-media",
    class: _vm.builderRatio
  }, [_vm.videoMp4 || _vm.videoWebm ? _c('video', {
    ref: "videoRef",
    staticClass: "lazyload img-fluid h-100",
    attrs: {
      "autoplay": _vm.autoPlay,
      "loop": "",
      "muted": "",
      "webkit-playsinline": "",
      "playsinline": "",
      "poster": _vm.src
    },
    domProps: {
      "muted": true
    },
    on: {
      "click": function click($event) {
        return _vm.toggleVideo($event);
      }
    }
  }, [_vm.videoWebm ? _c('source', {
    attrs: {
      "src": _vm.videoWebm
    }
  }) : _vm._e(), _vm._v(" "), _vm.videoMp4 ? _c('source', {
    attrs: {
      "src": _vm.videoMp4
    }
  }) : _vm._e()]) : _c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1441px)",
      "srcset": _vm.srcsets.xlarge.srcset
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 751px)",
      "srcset": _vm.srcsets.large.srcset
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 376px)",
      "srcset": _vm.srcsets.medium.srcset
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(max-width: 375px)",
      "srcset": _vm.srcsets.small.srcset
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "lazyload img-fluid h-100",
    attrs: {
      "src": _vm.src,
      "data-src": _vm.src,
      "alt": _vm.alt,
      "data-sizes": "auto"
    }
  })]), _vm._v(" "), _c('MdmIcon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isPaused && (_vm.videoMp4 || _vm.videoWebm),
      expression: "isPaused && (videoMp4 || videoWebm)"
    }],
    style: {
      fill: _vm.playColor
    },
    attrs: {
      "size": "50",
      "name": "play"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };